<template>
<!-- dataREal Map. --- {{ dataMap }}
    <hr>
    data Now ----{{  items }} -->
<!-- Minimal Navbar -->
<!-- <nav class="navbar">
        <div class="nav-container">
            <div class="nav-content">
                <div class="nav-left">
                    <div class="">
                              <i class="bi bi-water" style="font-size: 20px;"></i>
                    </div>
                    <span class="">WATER LEVEL</span>
                       <router-link  v-if="role!='user'|| role!='User'"
                            to='/management/group/list' 
                            class="">
                    <button type="button" class="btn btn-outline-dark px-2 py-1" >จัดการเพลตฟอร์ม</button>
                        </router-link>
                </div>
            </div>
        </div>
    </nav> -->

<div class="modal fade" id="favoriteModal" tabindex="-1" aria-labelledby="favoriteModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="favoriteModalLabel">รายการโปรด</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Save changes</button>
            </div>
        </div>
    </div>
</div>

<transition name="map-loading-fade">
    <div class="map-loading" v-if="mapLoading">
        <div class="map-loading-bg"></div>
        <div class="map-loading-box">
            <div class="map-loading-ring">
                <span class="map-loading-pulse"></span>
                <span class="map-loading-pulse p2"></span>
                <span class="map-loading-pulse p3"></span>
                <div class="map-loading-logo-wrap">
                    <img class="map-loading-logo" src="../assets/envionyx-logo.png" alt="loading" />
                </div>
            </div>
        </div>
    </div>
</transition>

<div class="" style="height: 100vh;" v-if="doneLoad">
    <nav class="navbar navbar-expand-lg navbar-light bg-light py-2 fexed-top" style="  z-index: 1000;padding: 0 1.5rem">
        <div class="container-fluid">
            <span class="">
                <!-- <i class="bi bi-tsunami" style="font-size: 20px;"></i> -->
                <!-- <i class="bi bi-soundwave" style="font-size: 20px;"></i> -->
                 <img src="../assets/envionyx-logo.png" alt="" style="height: 30px;">
                 <img class="ms-1" src="../assets/envionyx-banner.png" alt="" style="height: 18px;">
                 <!-- <img src="../assets/envionyx-logo.ico" alt=""> -->
                </span>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item ms-2">

                        <router-link v-if="role=='Owner'" to='/management/group/list' class="">
                            <button type="button" class="btn px-2 py-1 rounded-5 ms-lg-2 text-white" style="background: linear-gradient(135deg, #3E82D0FF 0%, #5CA9E8 100%); 
                   border: 0px solid rgba(255, 255, 255, 0.3);
                   box-shadow: 0 0 5px rgba(74, 144, 226, 0.5), 0 0 8px rgba(92, 169, 232, 0.4);">
                                <i class="bi bi-bezier2"></i> จัดการเพลตฟอร์ม
                            </button>
                        </router-link>
                        <!-- <router-link v-if="role!='User'"
                                    to='/management/group/list' 
                                    class="">
                            <button type="button" 
                                    class="btn px-2 py-1 rounded-5 ms-lg-2 text-white" 
                                    style="background: linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%);">
                                <i class="bi bi-bezier2"></i> จัดการเพลตฟอร์ม
                            </button>
                        </router-link> -->
                    </li>
                </ul>
                <form class="d-flex" style="">
                    <div class="col-12">
                        <div class="row py-2 px-0 rounded-5" style="background-color: #75BCEF1C;">
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-2 col-2">
                                <div style="height: 40px;width: 40px;background-color: #75BCEF;font-size: 16px;" class="rounded-circle text-center pt-2  text-white">
                                    WT
                                </div>
                            </div>
                            <div class="col-xl-6 col-xl-6 col-md-6 col-sm-8 col-8">
                                <div style="font-size: 11px;">
                                    {{ email }}
                                </div>
                                <div style="font-size: 12px;font-family: 'Kanit-Regular';">
                                    {{ role }}
                                </div>
                            </div>
                            <div class="col-1 dropdown text-end">
                                <div class="" type="button" id="navbarDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i class="bi bi-three-dots-vertical" style="font-size: 25px;"></i>
                                </div>
                                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                                    <router-link to="/info" style="text-decoration: none;">
                                        <li type="button"><a class="dropdown-item"><i class="bi bi-person"></i> บัญชีผู้ใช้</a></li>
                                    </router-link>
                                    <li type="button" @click="logout()"><a class="dropdown-item"><i class="bi bi-box-arrow-right"></i> ออกจากระบบ</a></li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
                    <button class="btn btn-outline-success" type="submit">Search</button> -->
                </form>
            </div>
        </div>
    </nav>

    <l-map ref="map" v-model:zoom="zoom" :center="centerPoint" @ready="onMapReady" class="main-map" style="font-family: 'Kanit-Regular';font-size: 18px;">
        <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" layer-type="base" name="OpenStreetMap">
        </l-tile-layer>
        <l-marker v-for="(item, index) in items" :key="index" :lat-lng="item.latLng">
            <l-icon class-name="custom-marker">
                <div class="marker-container" v-if="item.alarm_status==0">
                    <div class="marker-dot">
                        <i class="bi bi-water"></i>
                    </div>
                    <div class="marker-label">
                        {{ item.name.length > 25 ? item.name.substring(0, 25) + '...' : item.name }} <span>(ไม่พบข้อมูลเซนเซอร์)</span>
                    </div>
                    <!-- <div class="status-indicator" :class="{ 'online': item.status }"></div> -->
                </div>
                <div class="marker-container" v-if="item.alarm_status==1">
                    <div class="marker-dot">
                        <i class="bi bi-water"></i>
                    </div>
                    <div class="marker-label">
                        {{ item.name.length > 25 ? item.name.substring(0, 25) + '...' : item.name }}
                    </div>
                    <!-- <div class="status-indicator" :class="{ 'online': item.status }"></div> -->
                </div>
                <div class="marker-container" v-if="item.alarm_status==3">
                    <div class="marker-dot-warning">
                        <i class="bi bi-water" style="color: white;font-size: 18px;"></i>
                    </div>
                    <div class="marker-label-warning">
                        {{ item.name.length > 25 ? item.name.substring(0, 25) + '...' : item.name }}
                    </div>
                    <!-- <div class="status-indicator" :class="{ 'online': item.status }"></div> -->
                </div>

                <div class="marker-container" v-if="item.alarm_status==2">
                    <div class="marker-dot-danger">
                        <i class="bi bi-water" style="color: white;font-size: 18px;"></i>
                    </div>
                    <div class="marker-label-danger">
                        {{ item.name.length > 25 ? item.name.substring(0, 25) + '...' : item.name }}
                    </div>
                    <!-- <div class="status-indicator" :class="{ 'online': item.status }"></div> -->
                </div>

            </l-icon>

            <l-popup :closeButton="false" class="custom-popup">
                <div class="popup-content">
                    <h3 class="popup-title">{{ item.name.aaa }}</h3>

                    <div class="popup-data">
                        <div class="data-item" v-if="hasVal(item, 'IL')">
                            <i class="bi bi-water"></i>
                            <span class="data-label">ระดับน้ำ</span>
                            <span class="data-value">{{ item.device_data.IL }} CM</span>
                        </div>

                        <div class="data-item" v-if="hasVal(item, 'IT0')">
                            <i class="bi bi-thermometer-half"></i>
                            <span class="data-label">อุณหภูมิอากาศ</span>
                            <span class="data-value">{{ (item.device_data.IT0 / 10).toFixed(2) }} °C</span>
                        </div>

                        <div class="data-item" v-if="hasVal(item, 'IT1')">
                            <i class="bi bi-droplet-fill"></i>
                            <span class="data-label">อุณหภูมิในน้ำ</span>
                            <span class="data-value">{{ (item.device_data.IT1 / 10).toFixed(2) }} °C</span>
                        </div>

                        <div class="data-item" v-if="hasVal(item, 'ISAL')">
                            <i class="bi bi-percent"></i>
                            <span class="data-label">ความเค็ม</span>
                            <span class="data-value">{{ Number(item.device_data.ISAL).toFixed(2) }} ppt</span>
                        </div>

                        <div class="data-item" v-if="hasVal(item, 'ISAL')">
                            <i class="bi bi-moisture"></i>
                            <span class="data-label">ระดับความเค็ม</span>
                            <span class="data-value" :style="{ color: salinityLevel(item).color }">{{ salinityLevel(item).text }}</span>
                        </div>

                        <div class="data-item" v-if="showRain(item) && hasVal(item, 'IRAI')">
                            <i class="bi bi-cloud-drizzle"></i>
                            <span class="data-label">น้ำฝนสะสมใน 1 ชม.</span>
                            <span class="data-value">{{ (Number(item.device_data.IRAI) * 2.4).toFixed(2) }} mm</span>
                        </div>

                        <div class="data-item" v-if="hasVal(item, 'B')">
                            <i class="bi bi-lightning-charge-fill"></i>
                            <span class="data-label">แรงดัน</span>
                            <span class="data-value">{{ (item.device_data.B / 10).toFixed(2) }} V</span>
                        </div>

                        <div class="data-item">
                            <i class="bi bi-align-bottom"></i>
                            <span class="data-label">สถานะ</span>
                            <span class="data-value status-online" v-if="item.alarm_status==0">ไม่พบข้อมูลเซนเซอร์</span>
                            <span class="data-value status-online" v-if="item.alarm_status==1">ปกติ</span>
                            <span class="data-value " style="color: #FF8533;" v-else-if="item.alarm_status==3">เฝ้าระวัง</span>
                            <span class="data-value " style="color: #FB2C36;" v-else-if="item.alarm_status==2">วิกฤต</span>
                        </div>
                        <button @click="toggleBookmark(item.id)" type="button" class="btn  btn-light py-1 border" style="font-size: 14px;font-weight: bold;"><i class="bi bi-bookmark-star"></i> เพิ่มในรายการโปรด </button>
                    </div>

                    <router-link v-if="item.alarm_status!=0" :to="{ path: '/dashboard', query: { id: item.id }}" class="popup-link">
                        <i class="bi bi-arrow-right-circle"></i>
                        ไปยังแดชบอร์ด
                    </router-link>
                </div>
            </l-popup>
        </l-marker>
    </l-map>

    <!-- Search Bar -->
    <div class="label-box">
        <div class="label-on-box">

            <div class="col-12">
                <div class="row">
                    <div class="col-4">
                        <div class="col-12" style="height: 20px;background-color: #278c5b;"></div>
                    </div>
                    <div class="col-7" style="">ระดับปกติ</div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <div class="col-12" style="height: 20px;background-color: #FF7300DF;"></div>
                    </div>
                    <div class="col-7" style="">ระดับเฝ้าระวัง</div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <div class="col-12" style="height: 20px;background-color: #FB2C36;"></div>
                    </div>
                    <div class="col-7" style="">ระดับวิกฤต</div>
                </div>
            </div>

        </div>
    </div>

    <!-- Search Bar -->
    <div class="search-container">
        <div class="search-box">
            <i class="bi bi-search"></i>
            <input style="" class="input-search-box" type="text" v-model="searchQuery" placeholder="ค้นหาสถานีตรวจวัด" @keyup.enter="searchItems" @input="checkNon(searchQuery)" />
            <button @click="searchItems" class="search-btn">
                <i class="bi bi-search" style="color: #007b8b;"></i>
            </button>
        </div>
    </div>

    <div class="book-container">
        <div class="book-box">
            <button type="button" class="btn btn-light rounded-5 px-3 py-1">
                <i class="bi bi-bookmark-star" style="font-size: 14px;"></i> <span style="font-size: 14px;">รายการโปรด </span>
                <span style="height: 20px;width: 20px;background-color: #FFBB61;color: black;" class=" rounded-4     px-2 ">{{ bookItems.length }}</span>
            </button>
        </div>
    </div>

    <!-- Devices Panel -->
    <transition name="slide">
        <div v-if="!isMinimized" class="devices-panel">
            <div class="panel-header">
                <h3 style="font-weight: bold;">
                    <i class="bi bi-hdd-network"></i>
                    ตำแหน่งสถานีตรวจวัด
                </h3>
                <button @click="isMinimized = true" class="minimize-btn">
                    <i class="bi bi-dash-lg"></i>
                    <span class="px-2" style="font-size: 13px;;">ปิด</span>
                </button>
            </div>
            <div class="mt-2">
                <button @click="filter_state=1" type="button" class="btn btn-light border rounded-5 px-3 ms-2 py-1" :class="{ 'active-btn': filter_state === 1 }" style="font-size: 14px;">
                    ทั้งหมด
                </button>
                <button @click="filter_state=4" type="button" class="btn btn-light border rounded-5 px-3 ms-2 py-1" :class="{ 'active-btn': filter_state === 4 }" style="font-size: 14px;">รายการโปรด</button>
            </div>
            <div class="panel-body overflow-auto">
                <div class="devices-list" v-if="filter_state === 1">
                    <div v-for="(item) in items" :key="item.id">
                        <div type="button" @click="clickCenterLatLon(item,1000)" class="device-item" :class="{
                                'device-item-warning': item.alarm_status === 2,
                                'device-item-danger': item.alarm_status === 3
                                }">
                            <div class="device-status">
                                <span class="status-dot" :class="{
    offline: item.alarm_status === 0 || item.status === 0,
    online: item.alarm_status !== 0 && item.status !== 0
  }"></span>

                            </div>
                            <div class="device-info">

                                <div class="device-name-warning" v-if="item.alarm_status==3">
                                    {{ item.name.length > 25 ? item.name.substring(0, 20) + '...' : item.name }}
                                </div>
                                <div class="device-name-danger" v-else-if="item.alarm_status==2">
                                    {{ item.name.length > 25 ? item.name.substring(0, 20) + '...' : item.name }}
                                </div>
                                <div class="device-name" v-else-if="item.alarm_status==1">
                                    {{ item.name.length > 25 ? item.name.substring(0, 20) + '...' : item.name }}
                                </div>
                                <div class="device-name" v-else-if="item.alarm_status==0">
                                    {{ item.name.length > 25 ? item.name.substring(0, 20) + '...' : item.name }} <span class="ms-1" style="font-size: 10px;">(ไม่พบข้อมูลเซนเซอร์)</span>
                                </div>
                                <div class="device-temp">{{ (item.device_data?.IT0)/10 ?? N/A }} °C</div>
                                <div class="device-sal" v-if="hasVal(item, 'IAS')" :style="{ '--sal': salinityLevel(item).color }">
                                    <span class="device-sal-dot"></span>ความเค็ม {{ salinityLevel(item).text }}
                                </div>
                            </div>
                            <div class="device-level">
                                <span class="level-value">{{ item.water_height }}</span>
                                <span class="level-unit">{{ item.device_data?.IL ?? N/A }} CM</span>
                            </div>
                            <div class="device-actions">
                                <button class="btn bg-white px-2 py-1 " @click="toggleBookmark(item.id)">
                                    <i :class="[
        bookItems.includes(item.id)
          ? 'bi bi-bookmark-fill text-bookmark-active'
          : 'bi bi-bookmark'
      ]">
                                    </i>
                                </button>
                            </div>

                            <div class="device-actions">

                                <router-link v-if="item.alarm_status!=0" :to="{ path: '/dashboard', query: { id: item.id }}" class="action-btn">
                                    <i class="bi bi-eye"></i>
                                </router-link>
                                <div v-else class="action-btn " style="background-color: #C4C4C4FF;">
                                    <i class="bi bi-eye"></i>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="devices-list" v-if="filter_state === 4">
                    <div v-for="(item, index) in  filteredTems" :key="item.id" class="device-item" :class="{
                                'device-item-warning': item.alarm_status === 2,
                                'device-item-danger': item.alarm_status === 3}">
                        <span class="status-dot" :class="{
                            offline: item.alarm_status === 0 || item.status === 0,
                            online: item.alarm_status !== 0 && item.status !== 0
                        }"></span>

                        <div class="device-info">
                            <div class="device-name">
                                {{ item.name.length > 25 ? item.name.substring(0, 20) + '...' : item.name }}
                            </div>
                            <div class="device-temp">30.{{ index }} °C</div>
                        </div>
                        <div class="device-level">
                            <span class="level-value">{{ item.water_height }}</span>
                            <span class="level-unit">CM</span>
                        </div>

                        <div class="device-actions">
                            <button class="btn bg-white px-2 py-1 " @click="toggleBookmark(item.id)">
                                <i :class="[
                                bookItems.includes(item.id)
                                ? 'bi bi-bookmark-fill text-bookmark-active'
                                : 'bi bi-bookmark'
                            ]">
                                </i>
                            </button>
                        </div>

                        <div class="device-actions">

                            <router-link v-if="item.alarm_status!=0" :to="{ path: '/dashboard', query: { id: item.id }}" class="action-btn">
                                <i class="bi bi-eye"></i>
                            </router-link>
                            <div v-else class="action-btn">
                                <i class="bi bi-eye"></i>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </transition>

    <button v-if="isMinimized" @click="isMinimized = false" class="expand-btn">
        <i class="bi bi-list"></i>
        <span>สถานีตรวจวัด</span>
    </button>
</div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import projectIds from '../projectid.json';
import {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup
} from "@vue-leaflet/vue-leaflet";
import L from "leaflet";

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LIcon,
        LPopup
    },
    data() {
        return {
            email: localStorage.getItem("email"),
            role: localStorage.getItem("role"),
            dataMap: [],
            filter_state: 1,
            bookItems: [],
            isMinimized: false,
            searchQuery: "",
            zoom: 15,
            centerPoint: [14.8077, 101.5359],
            pendingFit: false,
            originalItems: [{
                    "name": "",
                    "latLng": {
                        "lat": 14.8077,
                        "lon": 101.5359
                    },
                },
                // {  
                //     "name": "เขื่อนลำตะคลอง",
                //     "latLng": { "lat": 14.807407717907903, "lon": 101.48424778491378 },
                //     "id": 85,
                //     "water_height": 150,
                //     "status": true,
                //     "alarm_status": 2
                // },
                // {

                //     "name": "ฟาร์มโชคชัย",
                //     "latLng": { "lat": 14.816852657086239, "lon": 101.50553321948746 },
                //     "id": 86,
                //     "water_height": 145,
                //     "status": true,
                //     "alarm_status": 3
                // },
                // {

                //     "name": "สะพานมอเตอร์เวย์ลำตะคอง",
                //     "latLng": { "lat": 14.833254807713207, "lon": 101.53309625055842 },
                //     "id": 87,
                //     "water_height": 160,
                //     "status": true,
                //     "alarm_status": 1
                // },
                // {

                //     "name": "ตลาดคลองไผ่",
                //     "latLng": { "lat": 14.85798921843854, "lon": 101.56115963186883 },
                //     "id": 88,
                //     "water_height": 155,
                //     "status": true,
                //     "alarm_status": 1
                // },
                // {

                //     "name": "จุดชมวิวหินพิมาน",
                //     "latLng": { "lat": 14.832474277156239, "lon": 101.5511432915936 },
                //     "id": 89,
                //     "water_height": 148,
                //     "status": true,
                //     "alarm_status": 1
                // },
                // {

                //     "name": "โรงเรียนน้ำซับศรีสุข",
                //     "latLng": { "lat": 14.810490972284864, "lon": 101.53904300979444 },
                //     "id": 90,
                //     "water_height": 152,
                //     "status": true,
                //     "alarm_status": 1
                // },
                // {

                //     "name": "บ้านหินฟ้า",
                //     "latLng": { "lat": 14.791588668740543, "lon": 101.52328248448228 },
                //     "id": 91,
                //     "water_height": 147,
                //     "status": true,
                //     "alarm_status": 1
                // },
                // {

                //     "name": "สถานีรถไฟสีคิ้ว",
                //     "latLng": { "lat": 14.782136899302836, "lon": 101.51450447038438 },
                //     "id": 92,
                //     "water_height": 143,
                //     "status": true,
                //     "alarm_status": 1
                // },
                // {

                //     "name": "วัดบ้านใหม่ลำตะคอง",
                //     "latLng": { "lat": 14.771913093645558, "lon": 101.49136243321716 },
                //     "id": 93,
                //     "water_height": 158,
                //     "status": true,
                //     "alarm_status": 1
                // },
                // {

                //     "name": "อ่างเก็บน้ำตอนบน",
                //     "latLng": { "lat": 14.848553534580018, "lon": 101.5492542298564 },
                //     "id": 94,
                //     "water_height": 162,
                //     "status": true,
                //     "alarm_status": 3
                // },
                // {

                //     "name": "เขื่อนลำตะคลอง (โซนเหนือ)",
                //     "latLng": { "lat": 14.779517361043826, "lon": 101.48002955952902 },
                //     "id": 95,
                //     "water_height": 149,
                //     "status": true,
                //     "alarm_status": 2
                // }
            ],
            items: [],
            doneLoad: true,
            mapLoading: true,
        }
    },
    computed: {
        filteredTems() {
            return this.items.filter(item => this.bookItems.includes(item.id));
        }
    },

    created() {
        this.getDataMap();
        this.items = this.originalItems;
        console.log("firest", this.items);
        var book = localStorage.getItem('bookItems');
        if (book) {
            this.bookItems = JSON.parse(book);
        }
    },
    mounted() {
        //   this.map = this.$refs.map.mapObject;
        // this.autoFitToMarkers();
    },

    methods: {
        // popup: มีค่าจริงไหม (null/undefined/ว่าง/NaN ถือว่าไม่มี) เหมือน hasValue ในหน้า dashboard
        hasVal(item, key) {
            const v = item && item.device_data ? item.device_data[key] : null
            return v !== null && v !== undefined && v !== '' && !(typeof v === 'number' && isNaN(v))
        },
        // ระดับความเค็มจาก IAS: 0,1 = ปกติ / 2 = สูงกว่าเกณฑ์ / ไม่มีค่า = N/A
        salinityLevel(item) {
            const raw = item && item.device_data ? item.device_data.IAS : null
            if (raw === null || raw === undefined || raw === '') return { text: 'N/A', color: '#8A8A8A' }
            const v = Number(raw)
            if (v === 0 || v === 1) return { text: 'ปกติ', color: '#1F9D63' }
            if (v === 2) return { text: 'สูงกว่าเกณฑ์', color: '#E5343D' }
            return { text: 'N/A', color: '#8A8A8A' }
        },
        // แสดงฝนเฉพาะ id ที่อยู่ใน src/projectid.json
        showRain(item) {
            return projectIds.includes(item.id)
        },
        clickCenterLatLon(item, size) {
            if (size <= 16) {
                // this.zoom=16
                this.centerPoint = [item.latLng.lat - 0.0025, item.latLng.lon]
            } else {
                this.centerPoint = [item.latLng.lat, item.latLng.lon]
            }

        },
        checkNon(input) {
            console.log(input)
            if (input == "") {
                console.log(input)
                console.log("input")
                this.items = this.originalItems;
            }
        },
        logout() {
            // localStorage.clear();
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("email");
            localStorage.removeItem("role");
            this.$router.push('/login')
        },
        getCenterLatLng(items) {
            let totalLat = 0;
            let totalLon = 0;
            let count = 0;

            items.forEach(item => {
                if (item.latLng) {
                    totalLat += item.latLng.lat;
                    totalLon += item.latLng.lon;
                    count++;
                }
            });

            if (count === 0) return null;

            this.centerPoint = [(totalLat / count) - 0.0025, totalLon / count];
            //   return {
            //     lat: (totalLat / count)-0.0025,
            //     lon: totalLon / count
            //   };
        },

        async autoRefreshToken() {
            const refreshToken = localStorage.getItem("refreshToken");

            try {
                const response = await fetch(`${process.env.VUE_APP_API_URL}/auth/refresh`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        refreshToken
                    })
                });

                const data = await response.json();

                if (data.accessToken) {
                    localStorage.setItem("accessToken", data.accessToken);
                    return true; // บอกว่า refresh สำเร็จ
                } else {
                    this.logout();
                    return false;
                }
            } catch (error) {
                console.error('Error refreshing token:', error);
                this.logout();
                return false;
            }
        },

        // จัด center + zoom อัตโนมัติให้เห็นทุกหมุด (vue-leaflet 0.10 ใช้ leafletObject ไม่ใช่ mapObject)
        autoFitToMarkers() {
            const list = (this.items || []).filter(m =>
                m.latLng && Number.isFinite(Number(m.latLng.lat)) && Number.isFinite(Number(m.latLng.lon))
            );
            if (list.length === 0) return;

            const map = this.$refs.map && this.$refs.map.leafletObject;
            if (!map) {
                this.pendingFit = true; // map ยังไม่พร้อม -> รอ @ready
                return;
            }
            this.pendingFit = false;

            const bounds = L.latLngBounds(list.map(m => L.latLng(Number(m.latLng.lat), Number(m.latLng.lon))));
            // padding กันหมุดชิดขอบ, maxZoom กันซูมเข้าใกล้เกินไปเมื่อมีหมุดเดียว/ใกล้กันมาก
            map.fitBounds(bounds, { padding: [60, 60], maxZoom: 16 });
        },
        onMapReady() {
            if (this.pendingFit) this.autoFitToMarkers();
        },

        async getDataMap() {
            try {
                var accessToken = localStorage.getItem("accessToken");
                this.loading = true;

                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/page/maps`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });

                if (!response.ok) {
                    const refreshed = await this.autoRefreshToken();
                    if (refreshed) {
                        return this.getDataMap(); // เรียกใหม่
                    }
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                this.dataMap = data.data.plans || [];
                //  "latLng": { "lat": 14.807407717907903, "lon": 101.48424778491378 },
                //  "latLng": { "lat": 13.9077, "lon": 100.4959 }
                const converted = await data.data.plans.map(item => ({
                    ...item,
                    alarm_status: item.device_data?.IA?? 0,
                    latLng: {
                        lat: item.Latitude,
                        lon: item.Longitude
                    }
                }));

                if (converted.length > 0) {
                    this.getCenterLatLng(converted)
                    this.items = converted; // update reactive variable ก่อน
                    this.originalItems = converted;
                    // รอ map render เสร็จ
                    this.$nextTick(() => this.autoFitToMarkers());
                }

                this.items = converted;

            } catch (error) {
                console.error('Error fetching dashboard data:', error);
                this.list_device = [];
            } finally {
                this.mapLoading = false;
            }
        },

        toggleBookmark(id) {
            // โหลดค่าจาก localStorage
            let book = localStorage.getItem('bookItems');
            if (book) {
                this.bookItems = JSON.parse(book);
            } else {
                this.bookItems = [];
            }

            // ตรวจว่ามี id นี้อยู่แล้วไหม
            const index = this.bookItems.indexOf(id);

            if (index !== -1) {
                // ถ้ามีอยู่แล้ว → ลบออก
                this.bookItems.splice(index, 1);
            } else {
                // ถ้ายังไม่มี → เพิ่มเข้าไป
                this.bookItems.push(id);
            }

            // บันทึกกลับลง localStorage
            localStorage.setItem('bookItems', JSON.stringify(this.bookItems));
        },
        searchItems() {
            if (!this.searchQuery) {
                this.items = this.originalItems;
            } else {
                this.items = this.originalItems.filter(item =>
                    item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
                );
            }
        }
    }
}
</script>

<style scoped>
/* ป้องกันการปรับขนาดตัวอักษรอัตโนมัติในมือถือ */
* {
    -webkit-text-size-adjust: 100%;
    -moz-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    text-size-adjust: 100%;
}

/* กำหนด base font-size ให้คงที่ */
html {
    font-size: 16px !important;
}

body {
    font-size: 1rem !important;
}

/* ใช้ clamp สำหรับ responsive font-size ที่มีขอบเขตชัดเจน */
.marker-label,
.marker-label-warning,
.marker-label-danger {
    font-size: clamp(0.7rem, 2.5vw, 0.85rem) !important;
}

.device-name,
.device-name-warning,
.device-name-danger {
    font-size: clamp(0.8rem, 2.5vw, 0.875rem) !important;
}

.popup-title {
    font-size: clamp(0.9rem, 3vw, 1rem) !important;
}

.data-label,
.data-value {
    font-size: clamp(0.8rem, 2.5vw, 0.875rem) !important;
}

.text-bookmark-active {
    color: #fea41cbb;
    /* สีส้มสำหรับสถานะที่ถูกบุ๊คมาร์ค */
}

.text-bookmark-active {
    color: #fea41cbb;
    /* สีส้มสำหรับสถานะที่ถูกบุ๊คมาร์ค */
}

.active-btn {
    font-weight: bold !important;
    background-color: #0ea4e9b1 !important;
    color: white !important;
    border-color: #f7f7f7d6 !important;
    transition: 0.3s;
}

* {
    /* margin: 0;
    padding: 0; */
    box-sizing: border-box;
}

/* .navbar {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    position: sticky;
    top: 0;
    z-index: 1000;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.nav-container {
    max-width: 100%;
    padding: 0 2rem;
}

.nav-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 4rem;
}

.nav-left {
    display: flex;
    align-items: center;
    gap: 0.875rem;
} */

.logo-badge {
    background: linear-gradient(135deg, #0ea4e9a7 0%, #0ea4e9a7 100%);
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.3);
}

.logo-badge i {
    color: white;
    font-size: 1.25rem;
}

.logo-text {
    font-size: 1.125rem;
    font-weight: 600;
    color: #0f172a;
    letter-spacing: -0.02em;
}

.user-badge {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}

.user-badge:hover {
    background: #e2e8f0;
}

.user-badge i {
    font-size: 1.5rem;
    color: #64748b;
}

/* Map */
.map-wrapper {
    position: relative;
    width: 100%;
    /* height: 100vh; */
    height: calc(100vh - 4rem);
    overflow: hidden;
}

.main-map {
    width: 100%;
    height: 100%;
    z-index: 0;
}

/* Custom Marker */
/* .marker-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.marker-dot {
    width: 1.8rem;
    height: 1.8rem;
    background: linear-gradient(135deg, #0ea4e9a7 0%, #0ea4e9d6 100%);
    border: 2px solid white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    color:#2F8795;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.4);
    cursor: pointer;
    transition: all 0.3s;
} */

.marker-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.marker-dot {
    position: relative;
    width: 2.4rem;
    height: 2.4rem;
    background: linear-gradient(135deg, #278c5b 0%, #3e9e70dd 100%);
    border: 2px solid white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2F8795;
    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.4);
    cursor: pointer;
    overflow: visible;
    /* ให้ ripple โผล่ออกนอกได้ */
}

.marker-dot-warning {
    position: relative;
    width: 2.4rem;
    height: 2.4rem;
    background: linear-gradient(135deg, #ff8533e1 0%, #ff8533c8 100%);
    border: 2px solid white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2F8795;
    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.4);
    cursor: pointer;
    overflow: visible;
    /* ให้ ripple โผล่ออกนอกได้ */
}

/* Ripple effect ตลอดเวลา */
.marker-dot-warning::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #ff8533b5;
    transform: translate(-50%, -50%) scale(1);
    animation: ripple-loop 2s ease-out infinite;
}

.marker-dot-danger {
    position: relative;
    width: 2.4rem;
    height: 2.4rem;
    background: linear-gradient(135deg, #fb2c36c2 0%, #fb2c36bf 100%);
    border: 2px solid white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2F8795;
    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.4);
    cursor: pointer;
    overflow: visible;
    /* ให้ ripple โผล่ออกนอกได้ */
}

/* Ripple effect ตลอดเวลา */
.marker-dot-danger::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #fb2c36d6;
    transform: translate(-50%, -50%) scale(1);
    animation: ripple-loop 2s ease-out infinite;
}

/* Ripple effect ตลอดเวลา */
/* .marker-dot::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(14, 164, 233, 0.4);
  transform: translate(-50%, -50%) scale(1);
  animation: ripple-loop 2s ease-out infinite;
} */

/* Keyframes ให้ ripple ค่อยๆ ขยายและจางหาย */
@keyframes ripple-loop {
    0% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 0.6;
    }

    70% {
        transform: translate(-50%, -50%) scale(2.5);
        opacity: 0;
    }

    100% {
        opacity: 0;
    }
}

.marker-dot:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px #278c5b;
}

.marker-dot i {
    color: white;
    font-size: 1rem;
}

.marker-label {
    border: 2px solid #278c5b;
    margin-top: 0.2rem;
    padding: 0.15rem 0.5rem;
    background: white;
    border-radius: 0.5rem;
    font-size: 0.79rem;
    font-weight: 500;
    color: #0f172a;
    white-space: nowrap;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.marker-label-warning {
    border: 2px solid #fe924fba;
    margin-top: 0.2rem;
    padding: 0.15rem 0.5rem;
    background: white;
    border-radius: 0.5rem;
    font-size: 0.75rem;
    font-weight: 500;
    color: #0f172a;
    white-space: nowrap;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.marker-label-danger {
    border: 2px solid #eb5e67b1;
    margin-top: 0.2rem;
    padding: 0.15rem 0.5rem;
    background: white;
    border-radius: 0.5rem;
    font-size: 0.75rem;
    font-weight: 500;
    color: #0f172a;
    white-space: nowrap;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.status-indicator {
    position: absolute;
    top: -2px;
    right: -2px;
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    border: 2px solid white;
    background: #22c55e;
}

/* Popup */
.popup-content {
    padding: 0.1rem;
    min-width: 210px;
}

.popup-title {
    font-size: 1rem;
    font-weight: 600;
    color: #0f172a;
    margin-bottom: 0.4rem;
}

.popup-data {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    margin-bottom: 0.3rem;
}

.data-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.3rem 0.5rem;
    background: #f8fafc;
    border-radius: 0.5rem;
}

.data-item i {
    color: #2F8795;
    font-size: 1.125rem;
}

.data-label {
    flex: 1;
    font-size: 0.87rem;
    font-family: 'Kanit-Regular';
    color: #4b4b4b;
}

.data-value {
    font-weight: 600;
    color: #0f172a;
    font-size: 0.875rem;
}

.status-online {
    color: #22c55e;
}

.popup-link {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.625rem;
    background: linear-gradient(135deg, #0ea4e9a7 0%, #0ea4e9ab 100%);
    color: white;
    text-decoration: none;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    font-weight: 500;
    transition: all 0.2s;
}

.popup-link:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.4);
}

/* .book-container {
    position: absolute;
    top: 1.3rem;
    left: 25%;
    transform: translateX(-50%);
    z-index: 501;
}

.book-box {
    display: flex;
    align-items: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  
} */
.book-container {
    position: absolute;
    top: 9.5vh;
    /* top: 86px; */
    left: 20rem;
    transform: none;
    /* เอา translateX ออก เพราะไม่ต้องการเลื่อนตรงกลางอีกแล้ว */
    z-index: 501;
}

.book-box {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.4rem 1rem;
    min-width: 200px;

}

/* ✅ เพิ่ม padding-top เมื่อหน้าจอเล็กกว่า 768px */
@media (max-width: 768px) {
    .book-container {
        top: 13.5vh;
        /* เพิ่มระยะจากด้านบนมากขึ้น เช่น จาก 1.3 → 3rem */
        left: 2.2rem;
    }

    /* หรือถ้าต้องการเพิ่ม padding-top ในกล่องแทน */
    .book-box {
        padding-top: 1rem;
        /* เพิ่ม padding เฉพาะในมือถือ */
    }
}

.book-box i {
    color: #94a3b8;
    font-size: 1.125rem;
}

.label-box {
    /* position: absolute;
    bottom: 0.1rem;
    left: 1rem;
    transform: none; 
    z-index: 1000; */
    font-size: 14px;
    width: 200px;
    position: fixed !important;
    bottom: 0;
    bottom: 0.1rem;
    left: 0.4rem;
    top: auto !important;
    max-height: none !important;
    border-radius: 0;
    margin: 0;
    box-shadow: none;
    z-index: 500;
    display: flex;
    flex-direction: column;
}

.label-on-box {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.2rem 0.4rem;
    background: white;
    border-radius: 0.3rem;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    /* min-width: 320px; */
}

/* .search-container {
    position: absolute;
    top: 1.0rem;
    left: 12%;
    transform: translateX(-50%);
    z-index: 500;
}

.search-box {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.4rem 1rem;
    background: white;
    border-radius: 3rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    min-width: 320px;
} */
.search-container {
    position: absolute;
    top: 9.95vh;
    /* top: 90px; */
    left: 3rem;
    z-index: 500;
}

.search-box {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    padding: 0.3rem 1rem;
    background: white;
    border-radius: 3rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    /* width: 10rem; */
}

.search-box i {
    color: #94a3b8;
    font-size: 1.125rem;
}

.search-box input {

    flex: 1;
    border: none;
    outline: none;
    font-size: 0.9375rem;
    color: #0f172a;
}

.search-box input::placeholder {
    color: #94a3b8;
}

.search-btn {
    width: 2rem;
    height: 2rem;
    /* background: linear-gradient(135deg, #0ea5e9 0%, #3b82f6 100%); */
    border: none;
    border-radius: 50%;
    color: #007b8b;
    /* cursor: pointer; */
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.input-search-box {
    width: 10rem;
}

.search-btn:hover {
    transform: scale(1.05);
}

@media (max-width: 768px) {

    .label-box {
        /* position: absolute;
    bottom: 0.1rem;
    left: 1rem;
    transform: none; 
    z-index: 1000; */
        width: 135px;
        font-size: 11px;
        position: fixed !important;
        bottom: 0;
        bottom: 0.1rem;
        left: 0.4rem;
        top: auto !important;
        max-height: none !important;
        border-radius: 0;
        margin: 0;
        box-shadow: none;
        z-index: 500;
        display: flex;
        flex-direction: column;
    }

    .search-box {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.2rem 0.5rem;

        border-radius: 3rem;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    }

    .devices-panel {
        position: fixed !important;
        bottom: 0;
        left: 0;
        right: 0;
        top: auto !important;
        width: 100vw;
        /* เต็มหน้าจอมือถือ */
        height: 50vh;
        /* เต็มหน้าจอมือถือ */
        max-height: none !important;
        border-radius: 0;
        margin: 0;
        box-shadow: none;
        z-index: 1002;
        display: flex;
        flex-direction: column;

    }

    .panel-header {
        border-radius: 0;
    }

    .panel-body {
        flex: 1;
        overflow-y: auto;
    }
}

/* Devices Panel */
.devices-panel {

    position: absolute;
    top: 5rem;
    right: 1.5rem;
    width: 400px;
    max-height: calc(100vh - 7rem);
    background: white;
    border-radius: 1rem;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    z-index: 508;
}

.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.25rem 1.5rem;
    border-bottom: 1px solid #f1f5f9;
}

.panel-header h3 {
    font-size: 1rem;
    font-weight: 600;
    color: #0f172a;
    display: flex;
    align-items: center;
    gap: 0.625rem;
}

.panel-header i {
    color: #0ea5e9;
}

.minimize-btn {
    /* width: 2rem; */
    height: 2rem;
    border: none;
    background: #f1f5f9;
    border-radius: 0.5rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.minimize-btn:hover {
    background: #e2e8f0;
}

.panel-body {
    flex: 1;
    overflow: hidden;
}

.devices-list {
    height: 100%;
    overflow-y: auto;
    padding: 0.75rem;
}

.device-item {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.4rem;
    margin-bottom: 0.5rem;
    background: #f8fafc;
    border-radius: 0.75rem;
    transition: all 0.2s;
}

.device-item-warning {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.4rem;
    margin-bottom: 0.5rem;
    background: #fff3e7;
    border-radius: 0.75rem;
    transition: all 0.2s;
}

.device-item-danger {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.4rem;
    margin-bottom: 0.5rem;
    background: #feeaea;
    border-radius: 0.75rem;
    transition: all 0.2s;
}

.device-item:hover {
    /* background: #f1f5f9; */
    transform: translateX(4px);
}

.device-status {
    flex-shrink: 0;
}

.status-dot {
    width: 0.625rem;
    height: 0.625rem;
    border-radius: 50%;
    display: block;
}

.status-dot.online {
    background: #22c55e;
    box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.2);
}

/* ออฟไลน์ = แดง */
.status-dot.offline {
    background-color: #f05b5b;
    box-shadow: 0 0 0 3px rgba(197, 34, 34, 0.2);
}

.device-info {
    flex: 1;
    min-width: 0;
}

.device-name {
    font-size: 0.875rem;
    font-weight: 500;
    color: #0f172a;
    margin-bottom: 0.25rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.device-name-warning {
    font-size: 0.875rem;
    font-weight: 500;
    color: #FF8533;
    margin-bottom: 0.25rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.device-name-danger {
    font-size: 0.875rem;
    font-weight: 500;
    color: #FB2C36;
    margin-bottom: 0.25rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.device-temp {
    font-size: 0.8rem;
    color: #323232;
}

.device-sal {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    margin-top: 0.15rem;
    padding: 0.05rem 0.65rem;
    border-radius: 999px;
    font-size: 0.82rem;
    font-weight: 700;
    line-height: 1.5;
    color: var(--sal);
    background: #fff;
    border: 1px solid color-mix(in srgb, var(--sal) 45%, transparent);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.device-sal-dot {
    width: 0.48rem;
    height: 0.48rem;
    border-radius: 50%;
    background: var(--sal);
}

.device-level {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.level-value {
    font-size: 1.125rem;
    font-weight: 600;
    color: #0ea5e9;
    line-height: 1;
}

.level-unit {
    font-size: 0.85rem;
    color: #313131;
    font-family: 'Kanit-Regular';
}

.device-actions {
    flex-shrink: 0;
}

.action-btn {
    width: 2rem;
    height: 2rem;
    background: white;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
    text-decoration: none;
    transition: all 0.2s;
}

.action-btn:hover {
    background: #0ea5e9;
    color: white;
}

/* Expand Button */
/* .expand-btn {
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;
    padding: 0.75rem 1.25rem;
    background: white;
    border: none;
    border-radius: 3rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 500;
    color: #0f172a;
    transition: all 0.2s;
    z-index: 500;
} */
.expand-btn {

    /* width: 135px;
    font-size: 11px;
      position: fixed !important;
    bottom: 0;
     bottom: 0.1rem;
    left: 0.4rem;
    top: auto !important;
    max-height: none !important;
    border-radius: 0;
    margin: 0;
    box-shadow: none;
    z-index: 500;
    display: flex;
    flex-direction: column; */

    /* position: absolute; */
    position: fixed !important;
    bottom: 1.0rem;
    /* เปลี่ยนจาก top เป็น bottom */
    right: 0.5rem;
    padding: 0.6rem 1.25rem;
    background: white;
    border: none;
    border-radius: 3rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 500;
    color: #0f172a;
    transition: all 0.2s;
    z-index: 500;
}

.expand-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
}

.expand-btn i {
    font-size: 1.25rem;
}

/* Animations */
.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s ease;
}

.slide-enter-from {
    transform: translateX(100%);
    opacity: 0;
}

.slide-leave-to {
    transform: translateX(100%);
    opacity: 0;
}

/* Responsive */
@media (max-width: 768px) {
    .devices-panel {
        width: calc(100% - 0.4rem);
        right: 0.2rem;
        left: 0.2rem;
    }

    .search-box {
        min-width: calc(100vw - 4rem);
    }

    .nav-container {
        padding: 0 1rem;
    }

    .logo-text {
        font-size: 1rem;
    }
}

/* Scrollbar */
.devices-list::-webkit-scrollbar {
    width: 6px;
}

.devices-list::-webkit-scrollbar-track {
    background: transparent;
}

.devices-list::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
}

.devices-list::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}
/* Loading (logo + วงกลมหมุน) */
.map-loading {
    position: fixed;
    inset: 0;
    z-index: 5000;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.map-loading-bg {
    position: absolute;
    inset: 0;
    background:
        radial-gradient(circle at 20% 15%, rgba(39, 140, 91, 0.12) 0, transparent 45%),
        radial-gradient(circle at 85% 90%, rgba(31, 157, 99, 0.10) 0, transparent 50%),
        linear-gradient(160deg, #ffffff 0%, #f1faf5 100%);
}
.map-loading-box {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.4rem;
}
.map-loading-ring {
    position: relative;
    width: 220px;
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.map-loading-pulse {
    position: absolute;
    inset: 68px;
    border-radius: 50%;
    border: 2px solid rgba(39, 140, 91, 0.45);
    background: rgba(39, 140, 91, 0.12);
    animation: mapLoadingPulse 2.4s ease-out infinite;
}
.map-loading-pulse.p2 { animation-delay: 0.8s; }
.map-loading-pulse.p3 { animation-delay: 1.6s; }
.map-loading-logo-wrap {
    position: relative;
    width: 84px;
    height: 84px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 6px 20px rgba(39, 140, 91, 0.2);
}
.map-loading-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
    animation: mapLoadingBreath 1.8s ease-in-out infinite;
}
@keyframes mapLoadingPulse {
    0% { transform: scale(0.7); opacity: 0.9; }
    100% { transform: scale(2.4); opacity: 0; }
}
@keyframes mapLoadingBreath {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.08); }
}
.map-loading-fade-leave-active { transition: opacity 0.4s ease; }
.map-loading-fade-leave-to { opacity: 0; }

</style>
